export const PAKISTAN_ID = 16;
export const UAE_ID = 18;
